export { default } from './OutlinedInput';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/OutlinedInput/index.js
// module id = 407
// module chunks = 2